const axios = require("axios");

export const getCodeVersion = async function () {
  if (process.env.REACT_APP_APPLICATION_ENV && process.env.REACT_APP_APPLICATION_ENV === "localhost") {
    return new Promise((resolve, reject) => {
      resolve(Math.random().toString(36).substring(2, 7));
    });
  } else {
    let codeVersionURL = `${process.env.REACT_APP_CODE_VERSION_URL}/${process.env.REACT_APP_BRANCH_CODE}.txt`;
    let req = await axios.get(codeVersionURL);
    return req.data;
  }
};
